
<template v-else>
  <div class="mb-3">
    <label class="form-label"
      >{{ customInput.label
      }}<span
        class="asterisk"
        :class="mode == 'write' ? 'red' : ''"
        v-if="customInput.mandatory"
        >*</span
      >      
      </label>
      <div v-if="isLoading" class="center"><div class="spinner-border text-info" style="width: 2.625rem; height: 2.625rem;" /></div>      
    <select
      :id="orderInput.itemId+'_'+customInput.id"
      class="form-select"
      :class="isValid ? '' : 'error'"
      v-if="mode == 'write' "
      v-model="selectVal"
      @change.stop="checkValid()"
    >
      <option selected :key="-1">請選擇</option>
      <option
        v-for="(opt, idx) in options"
        :key="idx"
        :value="opt.option"
        :selected="opt.selected"
        style="overflowWrap:break-word; whiteSpace: normal"
      >
        {{ opt.option }}
      </option>
    </select>    
    <div class="form-text error_msg" v-if="!isValid && mode == 'write'">
      請選擇{{ customInput.label }}！
    </div>
    <div class="input_answer" v-if="mode == 'read'">
      {{ answer.length > 0 ? answer.toString() : "未選擇" }}
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import useEventBus from "@/config/eventBus";
import ApiService from "@/services/ApiService.js";
import loading from "@/widgets/Loading.vue";

export default {	
  props: {
    inputList: {
      type: Object,
      required: true,
    },
    customInput: {
      type: Object,
      required: true,
    },
    orderInput: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const hasOption = ref(false);
    const isValid = ref(true);
    const eventBus = useEventBus();
    const selectVal = ref("請選擇");
    const options = ref([]);
    const isLoading = ref(false);

    const answer = computed(() =>
      props.customInput.infoInputOptions
        .filter((item) => item.selected)
        .map((item) => item.optionValue)
    );
    
    const checkValid = (/*args*/) => {
      if (props.mode == "write") {
        console.log("checkValid.");
        console.log(hasOption.value);
        console.log(props.orderInput);
        console.log(options);
        for (let i = 0; i < options.value.length; i++) {
            if(options.value[i].option ==selectVal.value){
            	props.orderInput.price =options.value[i].b2c_price;
            	break; 
            }
        }
        
        if (props.customInput.mandatory && hasOption.value) {
          selectVal.value == "請選擇"
            ? (isValid.value = false)
            : (isValid.value = true);
        }
        //if(args!=undefined && args[0].productItemId == props.orderInput.id ){
        if(isValid.value){
        	eventBus.emit("selectAPIValue", {
                id: props.customInput.id,
                val: selectVal.value,
              });
        }
        //}
      }
    };

    onMounted(() => {
      console.log(props.customInput);
      console.log(props.orderInput);
      props.isLoading=false;
      if (props.customInput.infoInputOptions != null) {
        for (let i = 0; i < props.customInput.infoInputOptions.length; i++) {
          options.value.push({
            option: props.customInput.infoInputOptions[i].optionValue,
            selected: true,
          });
          selectVal.value = props.customInput.infoInputOptions[i].optionValue;
        }
      }

      eventBus.on("checkValid", (argv) => {
        console.log(" on checkValid.");
        console.log(argv);
        console.log(props.customInput.id);
        isValid.value = true;
        if(argv!=undefined){
             document.getElementById(argv[0].productItemId+'_'+ props.customInput.id).dispatchEvent(new Event("change"));
        }
      });

      eventBus.on("resetSelectedValue", (questionKey) => {
    	  selectVal.value = "請選擇";
      	  eventBus.emit("selectAPIValue", {
              id: props.customInput.id,
              val: "",
            });
        });
      
      eventBus.on("productOptionSelected", (argv) => {
    	selectVal.value = "請選擇";
    	eventBus.emit("selectAPIValue", {
            id: props.customInput.id,
            val: "",
          });
    	//document.getElementById(argv.item.id+'_'+ props.customInput.id).dispatchEvent(new Event("change"));
        if (argv.item.id == props.orderInput.id && argv.item.qty > 0) {
          console.log("productOptionSelected");
          console.log(argv.item.qty);
          console.log(argv.item.date);
          console.log(options);
          var params =
            argv.item.id +
            "/" +
            argv.item.date +
            "/" +
            argv.item.qty +
            "/" +
            props.customInput.questionKey;
          options.value = [];
          isLoading.value=true;
          eventBus.emit("disableList");
          ApiService.getItemApiList(params, props.inputList).then((res) => {
            console.log(res);
            if (res.result != undefined) {
              console.log(res.result);
              options.value = res.result;
              hasOption.value = true;
            }
            isLoading.value=false;
            eventBus.emit("enableList");
          }).catch(function (err) {
        	  isLoading.value=false;    
        	  eventBus.emit("enableList");     
            });
        }
      });
    });

    onBeforeUnmount(() => {
      eventBus.off("checkValid");
      eventBus.off("productOptionSelected");
    });

    return {
        isLoading,
      options,
      selectVal,
      answer,
      isValid,
      checkValid,
    };
  },
};
</script>
